import styled from 'styled-components'
import { breakpoints } from '../../../../../../constants/breakpoints'

export const ItemName = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  margin: 0;

  @media (min-width: ${breakpoints.tabletMisc}px) {
    font-size: 13px;
  }
`
export const ItemPrice = styled.p<{ isOrderSummary: boolean }>`
  font-size: 12px;
  font-weight: 400;
  margin: 0;
`

export const IndividualOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Dot = styled.p.attrs(() => ({ role: 'separator' }))<{
  isOrderSummary: boolean
}>`
  margin: ${({ isOrderSummary }) =>
    isOrderSummary ? '0 4px 0 4px' : '4px 4px 4px 0px'};
`
